import ReactCodeMirror from '@uiw/react-codemirror';

/**
 * Workaround for https://github.com/uiwjs/react-codemirror/issues/640 where in Node environments (e.g. Jest) the
 * default export doesn't resolve properly.
 */
export const CodeMirror: typeof ReactCodeMirror =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  'default' in ReactCodeMirror ? (ReactCodeMirror as any).default : ReactCodeMirror;
